export default "__VITE_PUBLIC_ASSET__4cbe4d6e__"